<template>
  <div>
    <confirm-delete-row-category v-if="categoryToDelete" />
    <div v-else>
      <div id="button-div" v-if="!editCategory">
        <button
          id="addCategoryButton"
          class="btn btn-default"
          @click="activateEdit"
        >
          {{ $t('row_categories.add_category') }}
        </button>
      </div>
      <row-categories-form v-if="editCategory" />
      <row-categories-list v-else />
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import ConfirmDeleteRowCategory from './ConfirmDeleteRowCategory.vue';
import RowCategoriesForm from './RowCategoriesForm.vue';
import RowCategoriesList from './RowCategoriesList.vue';

export default {
  name: 'RowCategoriesContainer',
  components: {
    ConfirmDeleteRowCategory,
    RowCategoriesForm,
    RowCategoriesList
  },
  computed: mapState({
    editCategory: state => state.rowCategoriesModule.editCategory,
    categoryToDelete: state => state.rowCategoriesModule.categoryToDelete
  }),
  methods: {
    ...mapMutations('rowCategoriesModule', [
      'setEditCategory',
      'setCategoryToDelete'
    ]),
    activateEdit: function () {
      this.setEditCategory(true);
    }
  }
};
</script>

<style scoped>
#button-div {
  text-align: left;
}
</style>
